import gsap from 'gsap';
import * as scroll from './scroll';

/**
 * Triggers transition between pages.
 * Boolean is used to check whether its before or after type of transition.
 * @param {boolean} [after] 
 */
export function start(after) {
  if (after) {
    gsap.fromTo(page_transition, {clipPath: 'inset(0 0 0%)'}, {
      clipPath: 'inset(100% 0 0%)',
      duration: .6,
      onComplete: () => {
        scroll.disable(true);
      },
    })
  } else {
    scroll.disable();
    gsap.fromTo(page_transition, {clipPath: 'inset(0 0 100%)'}, {
      clipPath: 'inset(0 0 0%)',
      duration: .6,
    })
  }
}